import { cx } from "@suse-o11y/class-variance";
import React from "react";

import { Label } from "~/components/label";

import styles from "./_checkbox.module.css";

export interface CheckboxLabelProps extends React.ComponentProps<typeof Label> {
	children: React.ReactNode;
}

export const CheckboxLabel = React.forwardRef<React.ElementRef<typeof Label>, CheckboxLabelProps>(
	({ className, ...props }, ref) => <Label className={cx(styles.label, className)} ref={ref} {...props} />,
);

if (import.meta.env.DEV) {
	CheckboxLabel.displayName = "CheckboxLabel";
}
